import React from "react";
import ScheduleTable from "./partials/schedule-table.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import InlineNoticeLabel from "./partials/inline-notice-label.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import FilmActions from "../actions/FilmActions";
import FilmStore from "../stores/FilmStore";

class ReportScheduler extends React.Component {
  constructor(props) {
    super(props);
  }

  static getStores() {
    return [EventBucketStore, FilmStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getAllUserFilms: FilmStore.getAllUserFilms
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  componentWillMount() {
    EventBucketActions.fetchAll();
    FilmActions.fetchAllForUser();
  }

  render() {
    let styles = this.getStyles();

    const eventBuckets = this.props.getEventBuckets();
    const films = this.props.getAllUserFilms();

    if (eventBuckets.length === 0) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1 style={{ lineHeight: 1.2 }}>
          Scheduled Reports{" "}
          <InlineNoticeLabel
            label="Limited beta"
            style={{ marginLeft: 10, verticalAlign: "middle" }}
          />
        </h1>

        <p style={{ fontStyle: "italic" }}>
          You have been invited to the early-access Eventive Ledger Preview.
          Eventive Ledger powers the next generation of Eventive financial
          reporting tools and will be launching soon. Some features are not yet
          fully supported &ndash; as an early-access tester, please{" "}
          <a href="mailto:ledgerfeedback@eventive.org">let us know</a> what
          reporting functionality would be most useful to you or if you run into
          any issues!
        </p>

        <ScheduleTable buckets={eventBuckets} films={films} />
      </div>
    );
  }
}

export default connectToStores(ReportScheduler);



// WEBPACK FOOTER //
// ./src/app/components/report-scheduler.jsx